'use client'

import { isbot } from 'isbot'

import { useReportWebVitals } from 'next/web-vitals'

import * as gtag from '@lib/gtag'

export default function WebVitals(): null {
  useReportWebVitals((metric) => {
    // Same reason as the guard in sendEventToAnalytics: a crawler hit is not a session. Our own
    // lighthouse e2e job is one of them, and its metrics would land in GA next to real users'.
    if (isbot(navigator.userAgent)) {
      return
    }
    if (gtag) {
      gtag.event(metric.name, {
        event_category: metric.label === 'web-vital' ? 'Web Vitals' : 'Next.js custom metric',
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value), // values must be integers
        event_label: metric.id, // id unique to current page load
        non_interaction: true, // avoids affecting bounce rate.
      })
    }
  })

  return null
}
